module.exports = __webpack_public_path__ + "fonts/6b9bc3f93b7e075a5bbd89036880c2ee.txt";